import * as React from 'react';
import { Link } from 'react-router';

type MdxLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

const isRouterHref = (href?: string): href is string => {
  if (!href) {
    return false;
  }

  return href.startsWith('#') || (href.startsWith('/') && !href.startsWith('//'));
};

export const MdxLink: React.FC<MdxLinkProps> = ({ href, children, download, target, ...props }) => {
  if (isRouterHref(href) && !download && !target) {
    return (
      <Link {...props} to={href}>
        {children}
      </Link>
    );
  }

  return (
    <a {...props} download={download} href={href} target={target}>
      {children}
    </a>
  );
};
